import type { FC } from "react";

import { Button, Text } from "@alpacahq/ui/old";

type CommissionModelUpdatedProps = {
  model?: "tiered" | "fixed";
  onClose: () => void;
};

export const CommissionModelUpdated: FC<CommissionModelUpdatedProps> = ({
  onClose,
}) => (
  <div className="flex flex-col justify-center">
    <div className="flex items-center justify-center rounded bg-[#010101] p-4">
      <img
        src="resources/images/v2/commission-updated.svg"
        alt="Commission Update Requested"
        className="max-w-md object-contain"
      />
    </div>
    <Text className="pt-4 text-center">
      We have received your request to upgrade! <br />
      Our support team will contact you shortly once the change is complete.
    </Text>
    <Button onClick={onClose} className="mx-auto mt-4 w-full max-w-64">
      Sounds Good
    </Button>
  </div>
);
